:host {
  height: auto;
  box-sizing: border-box;
}

:host([disabled]) {
  opacity: 0.5;
  pointer-events: none;
}

.dropdown-menu-wrapper {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: stretch;
}

.content-wrapper {
  padding: calc(3 * var(--spacer));
}

.calendar-wrapper {
  display: inline-flex;
  justify-content: center;
  position: relative;
  flex-direction: row;
}

.time-picker-wrapper {
  display: flex;
  align-items: center;
  margin-bottom: calc(1.5 * var(--spacer));
  .label {
    font-family: var(--font-family-secondary);
    margin-right: calc(3 * var(--spacer));
  }
}

.calendar-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: calc(2.5 * var(--spacer));

  .footer-item {
    margin-left: calc(4 * var(--spacer));
  }
}

.navigate-current {
  &::part(button) {
    color: var(--chart-300-icon-buttons);
  }
}
